/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DayOfWeek } from './DayOfWeek';
import {
    DayOfWeekFromJSON,
    DayOfWeekFromJSONTyped,
    DayOfWeekToJSON,
    DayOfWeekToJSONTyped,
} from './DayOfWeek';

/**
 * 
 * @export
 * @interface DutyPreferenceParam
 */
export interface DutyPreferenceParam {
    /**
     * 
     * @type {DayOfWeek}
     * @memberof DutyPreferenceParam
     */
    weekday: DayOfWeek;
    /**
     * 
     * @type {boolean}
     * @memberof DutyPreferenceParam
     */
    aw12: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DutyPreferenceParam
     */
    aw3: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DutyPreferenceParam
     */
    bg: boolean;
}



/**
 * Check if a given object implements the DutyPreferenceParam interface.
 */
export function instanceOfDutyPreferenceParam(value: object): value is DutyPreferenceParam {
    if (!('weekday' in value) || value['weekday'] === undefined) return false;
    if (!('aw12' in value) || value['aw12'] === undefined) return false;
    if (!('aw3' in value) || value['aw3'] === undefined) return false;
    if (!('bg' in value) || value['bg'] === undefined) return false;
    return true;
}

export function DutyPreferenceParamFromJSON(json: any): DutyPreferenceParam {
    return DutyPreferenceParamFromJSONTyped(json, false);
}

export function DutyPreferenceParamFromJSONTyped(json: any, ignoreDiscriminator: boolean): DutyPreferenceParam {
    if (json == null) {
        return json;
    }
    return {
        
        'weekday': DayOfWeekFromJSON(json['weekday']),
        'aw12': json['aw12'],
        'aw3': json['aw3'],
        'bg': json['bg'],
    };
}

export function DutyPreferenceParamToJSON(json: any): DutyPreferenceParam {
    return DutyPreferenceParamToJSONTyped(json, false);
}

export function DutyPreferenceParamToJSONTyped(value?: DutyPreferenceParam | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'weekday': DayOfWeekToJSON(value['weekday']),
        'aw12': value['aw12'],
        'aw3': value['aw3'],
        'bg': value['bg'],
    };
}

